import { Component, HostListener } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, AlertController } from 'ionic-angular';
import { ConfigurationRoomsPage } from "../../configuration/configuration-rooms/configuration-rooms";
import { ConfigurationEstablishmentCreatePage } from "../../configuration/configuration-establishment/configuration-establishment-create/configuration-establishment-create";
import { Globals } from "../../../globals";
import { ConfigurationPasswordPage } from "../../configuration/configuration-password/configuration-password";
import { ConfigurationUsersPage } from "../../configuration/configuration-users/configuration-users";
import { ConfigurationServices } from "../../configuration/services";
import { ConfigurationTicketsPage } from "../../configuration/configuration-tickets/configuration-tickets";
import { ConfigurationCashsPage } from "../../configuration/configuration-cashs/configuration-cashs";
import { ConfigurationImagesPage } from "../../configuration/configuration-images/configuration-images";
import { ConfigurationPage } from '../../configuration/configuration';
import { LoginPage } from "../../auth/login/login";
import { AngularFireAuth } from 'angularfire2/auth';
import { ConfigurationUsersScreenBlockPage } from '../../configuration/configuration-users-screen-block/configuration-users-screen-block';
import { ConfigurationLogsPage } from '../../configuration/configuration-logs/configuration-logs';
import { ConfigurationThermalPrintersPage } from '../../configuration/configuration-thermal-printers/configuration-thermal-printers';
import { HomePage } from '../../home/home';
import { ConfigurationTicketPrintPage } from '../../configuration/configuration-tickets/configuration-ticket-print/configuration-ticket-print';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationIntegrationsPage } from '../../configuration/configuration-integrations/configuration-integrations';
import { ConfigurationTipsPage } from '../../configuration/configuration-tips/configuration-tips';
import { ConfigurationDeliveriesPage } from '../../configuration/configuration-deliveries/configuration-deliveries';
import { ConfigurationPaymentsChargesPage } from '../../configuration/configuration-payments-charges/configuration-payments-charges';
import { ConfigurationOrdersPage } from '../../configuration/configuration-orders/configuration-orders';
import { ConfigurationPaymentMethodsPage } from '../../configuration/configuration-payment-methods/configuration-payment-methods';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationDomainsPage } from '../../configuration/configuration-domains/configuration-domains';
import { ConfigurationSecondDisplaImagesPage } from '../../configuration/configuration-second-display-images/configuration-second-display-images';
import { ConfigurationComplementsPage } from '../../configuration/configuration-complements/configuration-complements';
import { ConfigurationAdvancedLogsPage } from '../../configuration/configuration-advanced-logs/configuration-advanced-logs';

/**
 * Generated class for the SideMenuPageConfig page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'partial-side-menu-config',
    templateUrl: 'side-menu-config.html',
})
export class SideMenuPageConfig {

    transactions_list = [];

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public afAuth: AngularFireAuth,
        public loadingCtrl: LoadingController,
        private alertCtrl: AlertController,
        public translate: TranslateService,
        public http: HttpClient) {
        this.configurationServices.getRestaurant(this.globals.restaurant_uid);
        this.getAllSuscriptionTransactions();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        var platform_width = window.innerWidth;
        var side_menu_config = document.getElementById('side_menu_config');

        if (platform_width < 600) {
            this.globals.platform_width = 'mobile';
            //
            if (side_menu_config != null) {
                side_menu_config.style.display = 'none';
            }
        } else if (platform_width >= 600 && platform_width < 1025) {
            this.globals.platform_width = 'tablet';
            //
            if (side_menu_config != null) {
                side_menu_config.style.display = 'none';
            }
        } else if (platform_width >= 1025) {
            this.globals.platform_width = 'desktop';
            //
            if (side_menu_config != null) {
                side_menu_config.style.display = 'none';
            }
        }
    }

    getAllSuscriptionTransactions() {

        /*const params = new HttpParams()
            .set('facturacion_id', this.globals.restaurant.facturacion_id);
        this.http.post(this.globals.api_gestio_path + 'pro/list/pay/customer', params, {})
            .subscribe(async res => {
                this.transactions_list = res['suscriptions'];
            });*/

        const params = new HttpParams()
            .set('facturacion_id', this.globals.restaurant.facturacion_id);
        this.http.post(this.globals.analytics_path + 'pro/list/pay/customer', params, {})
            .subscribe(async res => {
                this.transactions_list = res['suscriptions'];
            });
    }

    back() {
        this.globals.side_menu_config_active = '';
        this.navCtrl.setRoot(ConfigurationPage);
        this.globals.open_side_menu = false;
    }

    /*GENERAL*/

    openEstablishment() {
        this.globals.side_menu_config_active = "establishment";
        this.navCtrl.setRoot(ConfigurationEstablishmentCreatePage, {
            update_state: true,
            restaurant: this.configurationServices.restaurant,
        });
        this.globals.open_side_menu = false;
    }

    openTips() {
        this.globals.side_menu_config_active = 'tips';
        this.navCtrl.setRoot(ConfigurationTipsPage);
        this.globals.open_side_menu = false;
    }

    openResetPassword() {
        this.globals.side_menu_config_active = 'password';
        this.navCtrl.setRoot(ConfigurationPasswordPage);
        this.globals.open_side_menu = false;
    }

    openUsers() {
        this.globals.side_menu_config_active = 'users';
        this.navCtrl.setRoot(ConfigurationUsersPage);
        this.globals.open_side_menu = false;
    }

    openUsersScreenBlock() {
        if (!this.globals.checkLimitsByLicense('screen_block', 'block')) {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
            this.globals.side_menu_config_active = 'users_block_screen';
            this.navCtrl.setRoot(ConfigurationUsersScreenBlockPage);
        }
        this.globals.open_side_menu = false;
    }

    /*TPV*/

    openRooms() {
        this.globals.side_menu_config_active = 'rooms';
        this.navCtrl.setRoot(ConfigurationRoomsPage);
        this.globals.open_side_menu = false;
    }

    openTickets() {
        this.globals.side_menu_config_active = 'tickets';
        this.navCtrl.setRoot(ConfigurationTicketsPage, {
            headfooter: this.configurationServices.ticket_hedfoot,
        });
        this.globals.open_side_menu = false;
    }

    openConfPaymentMethods() {
        this.globals.side_menu_config_active = 'payment_methods';
        this.navCtrl.setRoot(ConfigurationPaymentMethodsPage);
        this.globals.open_side_menu = false;
    }

    openCashs() {
        this.globals.side_menu_config_active = 'cashs';
        this.navCtrl.setRoot(ConfigurationCashsPage);
        this.globals.open_side_menu = false;
    }

    openComplements() {
        this.globals.side_menu_config_active = 'variations';
        this.navCtrl.setRoot(ConfigurationComplementsPage);
        this.globals.open_side_menu = false;
    }

    openImages() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.setRoot(ConfigurationImagesPage);
        this.globals.open_side_menu = false;
    }

    openSecondDisplayImages() {
        this.globals.side_menu_config_active = 'second_display_images';
        this.navCtrl.setRoot(ConfigurationSecondDisplaImagesPage);
        this.globals.open_side_menu = false;
    }

    async openAddons() {
        //Si el restaurante tiene stripe_customer_id abrimos el url del dashboard de stripe
        if (this.globals.restaurant.stripe_customer_id != undefined && this.globals.restaurant.stripe_customer_id != '') {
            var portal_url = await this.globals.getStripeCustomerPortal();
            this.openLinkApp(portal_url['customer_portal_url']);
        }
    }

    openLinkApp(url) {
        if (this.globals.so_mobile) {
            window.location.assign(url);
        } else {
            window.open(url, '_blank');
        }
    }

    openIntegrations() {
        this.globals.side_menu_config_active = 'integrations';
        this.navCtrl.setRoot(ConfigurationIntegrationsPage);
        this.globals.open_side_menu = false;
    }

    openLogs() {
        this.globals.side_menu_config_active = 'logs';
        this.navCtrl.setRoot(ConfigurationLogsPage);
        this.globals.open_side_menu = false;
    }

    openThermalPrinters() {
        this.globals.side_menu_config_active = 'thermal_printers';
        this.navCtrl.setRoot(ConfigurationThermalPrintersPage);
        this.globals.open_side_menu = false;
    }

    openPaymentMethods() {
        if (this.globals.restaurant.license == 'free') {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        } else {
            this.globals.side_menu_config_active = 'payment_methods';
            this.navCtrl.setRoot(ConfigurationPaymentMethodsPage);
        }
        this.globals.open_side_menu = false;
    }

    home() {
        this.globals.side_menu_config_active = '';
        this.globals.side_menu_active = 'dashboard';
        this.navCtrl.setRoot(HomePage);
        this.globals.open_side_menu = false;
    }

    openAdvancedLogs() {
        this.globals.side_menu_config_active = 'advanced_logs';
        this.navCtrl.setRoot(ConfigurationAdvancedLogsPage);
        this.globals.open_side_menu = false;
    }

    logout() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-cerrar-sesion'),
            message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.delNotTokenAndLogout();
                        this.globals.open_side_menu = false;
                    }
                }
            ]
        });
        alert.present();
    }

    async delNotTokenAndLogout() {
        //funcion que borra token
        await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
        //hacemos logout de afAuth
        this.afAuth.auth.signOut()
            .then(authData => {
                // toast message
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('instant-cerrado-sesion'),
                    duration: 3000,
                    position: 'top'
                });
                toast.present();
                //
                if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
                    this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
                }
                //
                this.navCtrl.setRoot(LoginPage);
                window.location.reload();
            }, error => {
                //var errorMessage: string = error.message;
            });
    }

    openConfTicketPrint() {
        this.globals.side_menu_config_active = 'tickets';
        this.navCtrl.setRoot(ConfigurationTicketPrintPage, {
            headfooter: this.globals.restaurant.tickets,
        });
        this.globals.open_side_menu = false;
    }

    openConfDeliveries() {
        this.globals.side_menu_config_active = 'deliveries';
        this.navCtrl.setRoot(ConfigurationDeliveriesPage);
        this.globals.open_side_menu = false;
    }

    openConfPaymentsCharges() {
        this.globals.side_menu_config_active = 'payments_charges';
        this.globals.side_menu_active = '';
        this.navCtrl.push(ConfigurationPaymentsChargesPage);
        this.globals.open_side_menu = false;
    }

    openOrders() {
        this.globals.side_menu_config_active = 'orders';
        this.globals.side_menu_active = '';
        this.navCtrl.setRoot(ConfigurationOrdersPage);
        this.globals.open_side_menu = false;
    }

    openDomains() {
        this.globals.side_menu_config_active = 'domains';
        this.globals.side_menu_active = '';
        this.navCtrl.setRoot(ConfigurationDomainsPage);
        this.globals.open_side_menu = false;
    }

    openMenuAll() {
        //Menu
        const menu = document.getElementsByClassName('menu_config_tablet');
        for (let i = 0; i < menu.length; i++) {
            const slide = menu[i] as HTMLElement;
            slide.style.width = "";
        }

        //Boto obrir
        const open = document.getElementsByClassName('open_menu_all');
        for (let i = 0; i < open.length; i++) {
            const slide = open[i] as HTMLElement;
            slide.style.display = 'none';
        }
        //Boto tancar
        const close = document.getElementsByClassName('close_menu_all');
        for (let i = 0; i < close.length; i++) {
            const slide = close[i] as HTMLElement;
            slide.style.display = 'block';
        }

        //Textos dels icones
        const text = document.getElementsByClassName('side-menu-text');
        for (let i = 0; i < text.length; i++) {
            const slide = text[i] as HTMLElement;
            slide.style.display = "contents";
        }
    }

    closeMenuAll() {
        //Menu
        const menu = document.getElementsByClassName('menu_config_tablet');
        for (let i = 0; i < menu.length; i++) {
            const slide = menu[i] as HTMLElement;
            slide.style.width = "50px";
        }

        //Boto obrir
        const open = document.getElementsByClassName('open_menu_all');
        for (let i = 0; i < open.length; i++) {
            const slide = open[i] as HTMLElement;
            slide.style.display = 'block';
        }
        //Boto tancar
        const close = document.getElementsByClassName('close_menu_all');
        for (let i = 0; i < close.length; i++) {
            const slide = close[i] as HTMLElement;
            slide.style.display = 'none';
        }

        //Textos dels icones
        const text = document.getElementsByClassName('side-menu-text');
        for (let i = 0; i < text.length; i++) {
            const slide = text[i] as HTMLElement;
            slide.style.display = "none";
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/components/side-menu-config/side-menu-config.ts